export default __webpack_public_path__ + "navigation-examples-route-deserialize-thumbnail-v1-480-f8aca8c3c1c066f05a641d312a48c799.webp";